module.exports = __webpack_public_path__ + "media/images/application/template/basket-8025a423eb1e7f9e3574202ebff928e6.svg";